import {useGetData} from '../../src/apiservice/apiCall'


export function useGetCareer(){
	return useGetData('/api/WebApi/GetCareer')
}